import {RootState} from "../../store/rootReducer";
import {getGroupProgress} from "../utils/multicard.utils";
import {markupFormatter} from "../../common";

export const reviewActionBarSelector = (state: RootState) => {
   const cardId = state.review.cardId;
   const card = cardId != null && cardId !== '' ? state.cards[cardId] : undefined;
   const icon = card ? markupFormatter.parse(card.markup).icon : '';

   return {
      cardId: state.review.cardId!,
      cardNumberInReview: state.review.cardNumberInReview,
      totalCardsForReview: state.review.totalCardsForReview,
      groupProgress: getGroupProgress(state.review),
      icon,
   };
};
